import { Card } from "components/Card"
import { Image } from "components/Image"
import { useRouter } from "components/Router"
import { Text } from "components/Text"
import { useTranslator } from "components/Translator"
import { useId } from "react"
import * as styles from "./ForumTagCard.css?module"
import cx from "classnames"
import fallbackImageUrl from "img/background.jpg"

export const ForumTagCard = (props) => {
  const router = useRouter()
  const translator = useTranslator()

  return (
    <div className={"relative"}>
      <Card>
        <div className={"grid gap-1"}>
          {props.tag.imageFile ? (
            <Image
              imageFile={props.tag.imageFile}
              alt={""}
              size={"w480"}
              className={"w-full h-32 object-cover object-center"}
            />
          ) : (
            <img
              src={fallbackImageUrl}
              alt={""}
              className={"w-full h-32 object-cover object-center"}
              loading={"lazy"}
            />
          )}
          <div className={"px-2 py-1 grid gap-4"}>
            <Text
              variant={"headline5"}
              tag={"a"}
              href={router.generate("app_club_forum_tag", {
                forumTagSlug: props.tag.slug,
              })}
              className={cx(
                "block w-full text-center",
                styles.ForumTagCard__title,
              )}
            >
              {props.tag.title}
            </Text>
            <dl className={"grid grid-cols-2 gap-2"}>
              <Metric
                label={translator.transChoice(
                  "ForumTagCard.nbPosts.label",
                  props.tag.nbPosts,
                  null,
                  "components",
                )}
                value={props.tag.nbPosts}
              />
              <Metric
                label={translator.transChoice(
                  "ForumTagCard.nbReplies.label",
                  props.tag.nbReplies,
                  null,
                  "components",
                )}
                value={props.tag.nbReplies}
              />
            </dl>
            <Text variant={"headline6"} tag={"p"} className={"text-center"}>
              {translator.trans(
                "ForumTagCard.updatedAt",
                { date: new Date(props.tag.updatedAt).toLocaleDateString() },
                "components",
              )}
            </Text>
          </div>
        </div>
      </Card>
    </div>
  )
}

const Metric = (props) => {
  const id = useId()

  return (
    <div className={"text-center"}>
      <Text tag={"dt"} variant={"headline6"} id={id}>
        {props.label}
      </Text>
      <Text tag={"dl"} variant={"headline3"} aria-labelledby={id}>
        {props.value}
      </Text>
    </div>
  )
}
